import { attr, customElement, DOM, FASTElement, observable } from '@microsoft/fast-element';
import { RightSideModalTemplate as template } from './right-side-modal.template';
import { RightSideModalStyles as styles } from './right-side-modal.styles';
import { Dialog } from '@microsoft/fast-foundation';

@customElement({
  name: 'right-side-modal',
  template,
  styles,
})
export class RightSideModal extends FASTElement {
  @attr show: boolean = false;
  @attr allowOverlayClose: boolean = false;
  @attr header: string = '';
  @attr buttons: boolean = true;
  @observable public rightDialog: Dialog;
  @attr width: string = '554px';
  @attr classes = '';
  @attr closeModalHeader: string = '';
  @attr closeModalDescription: string = '';
  @attr confirmModalHeader: string = '';
  @attr confirmModalDescription: string = '';
  @observable notificationDialog: boolean = false;
  @observable confirmationDialog: boolean = false;

  connectedCallback() {
    super.connectedCallback();
    DOM.queueUpdate(() => {
      this.rightDialog.style.setProperty('--dialog-width', this.width);
    });
    if (this.allowOverlayClose) {
      this.rightDialog.addEventListener('cancel', () => this.closeDialog());
    }
  }

  showChanged() {
    if (this.rightDialog) {
      const _show: any = this.show;
      if (!this.show || _show === 'false') {
        this.rightDialog.hide();
      } else {
        this.rightDialog.show();
      }
    }
  }

  public closeDialog() {
    if (!(this.closeModalHeader && this.closeModalDescription)) {
      this.$emit('modalClosing', true);
      this.rightDialog.hide();
    } else {
      this.notificationDialog = true;
    }
    this.confirmationDialog = false;
  }

  public toggleDialog(isClosedModal: boolean) {
    this.notificationDialog = false;

    if (isClosedModal) {
      this.$emit('modalClosing', true);
      this.rightDialog.hide();
    }
  }

  public confirmDialog() {
    this.confirmationDialog = true;
  }

  public toggleConfirmationDialog(isConfirmModal: boolean) {
    this.confirmationDialog = false;
    this.$emit('confirmationClosing', isConfirmModal);
  }

  public getOpenStatus() {
    if (this.rightDialog) {
      return this.rightDialog.hidden ? 'closed' : 'open';
    }

    return '';
  }

  widthChanged(oldValue, newValue) {
    this.rightDialog?.style.setProperty('--dialog-width', newValue);
  }
}
